import PropTypes from 'prop-types'
import React from 'react'

const contact = props => {

  const { article, articleTimeout, menuBar, redirectClick, close } = props;

  const sendMessage = e => { e.preventDefault(); }
  return (
    <article
      id="contact"
      className={`${article === 'contact' ? 'active' : ''} ${articleTimeout ? 'timeout' : ''}`}
      style={{ display: 'none' }}
    >
      <h2 className="major">Contact</h2>
      <h3>Need for Collaboration? Please Send Me a Message.</h3>
      <form method="post" name="contact" netlify>
        <input type="hidden" name="form-name" value="contact" />
        <div className="field half first">
          <label htmlFor="name" required>Name</label>
          <input type="text" name="name" id="name" required/>
        </div>
        <div className="field half">
          <label htmlFor="email">Email</label>
          <input type="text" name="email" id="email" required />
        </div>
        <div className="field">
          <label htmlFor="message">Message</label>
          <textarea name="message" id="message" rows="4" required></textarea>
        </div>
        <ul className="actions">
          <li>
            <button type="submit" className="special">Submit</button>
          </li>
          <li>
            <input type="reset" value="Reset" />
          </li>
        </ul>
      </form>
      <ul className="icons">
        <li>
          <a
            target="_blank" rel="noreferrer"
            href="https://twitter.com/LeonilOmayan93?s=09"
            className="icon fab fa-twitter"
          >
            <span className="label">Twitter</span>
          </a>
        </li>
        <li>
          <a
            target="_blank" rel="noreferrer"
            href="https://facebook.com/leonil.omayan"
            className="icon fab fa-facebook-f">
            <span className="label">Facebook</span>
          </a>
        </li>
        <li>
          <a
            target="_blank" rel="noreferrer"
            href="https://instagram.com/leo_nil_"
            className="icon fab fa-instagram">
            <span className="label">Instagram</span>
          </a>
        </li>
        <li>
          <a
            target="_blank" rel="noreferrer"
            href="https://github.com/Leonil1993"
            className="icon fab fa-github"
          >
            <span className="label">GitHub</span>
          </a>
        </li>
        <li>
          <a
            href="tel:+639059538246"
            className="icon fas fa-phone"
          >
            <span className="label">Phone Number</span>
          </a>
        </li>
        {/*<li className={`menu-brand-item ${props.menuBar ? 'show' : '' }`}>
              <a
                target="_blank" rel="noreferrer"
                href="https://www.google.com.ph/maps/@7.1032078,125.4992702,18z"
                className="icon fa-map"
              >
                <span className="label">Map</span>
              </a>
            </li>*/}
        <li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
          <a
            href="mailto:leonil.omayan.lo@gmail.com"
            className="icon far fa-envelope"
          >
            <span className="label">Map</span>
          </a>
        </li>
      </ul>

      <div className="pagination">
        <div className="pagination-left">
          <button onClick={() => { redirectClick('project'); }}><span className="icon fas fa-arrow-left"></span> Projects</button>
        </div>
        <div className="pagination-right">
        </div>
      </div>

      {close}
    </article>
  );
}

contact.propTypes = {
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  close: PropTypes.object
}

export default contact
